import { useEffect, useState, useRef } from 'react';
import '../assets/Media.css';
import Whatsapp from './Whatsapp';

// Carousel Images
import news from '../assets/imgs/Banner/media-banner.webp';
import launch from '../assets/events/launch.webp';
import inauguration_celebration from '../assets/events/inauguration_celebration.webp';

// Event Images
import directors_speech from '../assets/events/directors_speech.webp';
import our_team from '../assets/events/our_team.webp';
import mind_blowing_speech from '../assets/events/mind_blowing_speech.webp';
import award from '../assets/events/award.webp';
import office_celebration from '../assets/events/office_celebration.webp';
import office_function from '../assets/events/office_function.webp';
import office_team from '../assets/events/office_team.webp';
import activity from '../assets/events/activity.webp';
import award_ceremony from '../assets/events/award_ceremony.webp';
import celebration from '../assets/events/celebration.webp';
import ceremony from '../assets/events/ceremony.webp';
import cp from '../assets/events/cp.webp';
import dahi_handi from '../assets/events/dahi_handi.webp';
import dedication from '../assets/events/dedication.webp';
import director_speech from '../assets/events/director_speech.webp';
import diwali_offer from '../assets/events/diwali_offer.webp';
import establishment from '../assets/events/establishment.webp';
import event from '../assets/events/event.webp';
import food from '../assets/events/food.webp';
import ganesh_chaturthi from '../assets/events/ganesh_chaturthi.webp';
import group from '../assets/events/group.webp';
import honour from '../assets/events/honour.webp';
import Induction from '../assets/events/Induction.webp';
import life_changing from '../assets/events/life_changing.webp';
import lonavala_conference from '../assets/events/lonavala_conference.webp';
import lonavala_event from '../assets/events/lonavala_event.webp';
import lonavala_speech from '../assets/events/lonavala_speech.webp';
import occurrence from '../assets/events/occurrence.webp';
import open from '../assets/events/open.webp';
import opening from '../assets/events/opening.webp';
import our_director from '../assets/events/our_director.webp';
import presentation from '../assets/events/presentation.webp';
import romance_with_sales from '../assets/events/romance_with_sales.webp';
import site_visit from '../assets/events/site_visit.webp';
import speech from '../assets/events/speech.webp';
import team from '../assets/events/team.webp';
import unit from '../assets/events/unit.webp';
import workforce from '../assets/events/workforce.webp';

import eCarousel from '../assets/events/event-carousel.webp';
import eCarousel2 from '../assets/events/event-carousel2.webp';
import sakalpuraskar from '../assets/imgs/sakal-gaurav-puraskar.webp';
import panshetmahotsav from '../assets/imgs/hero-banner2.webp';
import pm1 from '../assets/gallery/pm1.webp';
import pm2 from '../assets/gallery/pm2.webp';
import pm3 from '../assets/gallery/pm3.webp';
import pm4 from '../assets/gallery/pm4.webp';
import pm5 from '../assets/gallery/pm5.webp';
import ssg from '../assets/events/velhe-samriddhi-sohala.webp';
import ssg2 from '../assets/events/ssg-2.webp';
import expo26 from '../assets/gallery/expo-jan-2026.JPG';
import republic from '../assets/imgs/26th_jan.JPG';


const slides = [

    {
        img: panshetmahotsav,
        text: `100+ families explored Waterscape,closed 50% bookings in a single day! `,
    },
    {
        img: sakalpuraskar,
        text: `the prestigious
सकाळ गौरव गाथा पुरस्कार For Sustainable Development! 
- 24-June-2025`,
    },

    {
        img: eCarousel,
        text: "Launching of Blue Horizon @Hinjewadi Annexe",

    },
    {
        img: news,
        text: "Every Moment That Matters — Our Story in News & Events",
    },
    {
        img: eCarousel2,
        text: "Music celebration unites hearts"
    },
    {
        img: launch,
        text: "Unveiling Dreams",
    },
    {
        img: inauguration_celebration,
        text: "Celebrating New Beginnings With You",
    },
];

const eventImages = [
    republic,expo26,ssg,ssg2,pm1,pm2,pm3,pm4,pm5,
    directors_speech, our_team, mind_blowing_speech, award,
    office_celebration, office_function, office_team, activity,
    award_ceremony, celebration, ceremony, cp,
    dahi_handi, dedication, director_speech, diwali_offer,
    establishment, event, food, ganesh_chaturthi,
    group, honour, inauguration_celebration, Induction,
    launch, life_changing, lonavala_conference, lonavala_event,
    lonavala_speech, occurrence, open, opening,
    our_director, presentation, romance_with_sales, site_visit,
    speech, team, unit, workforce,
];

function Media() {
    const [activeIndex, setActiveIndex] = useState(0);
    const [visibleCount, setVisibleCount] = useState(5);
    const [showModal, setShowModal] = useState(false);
    const [modalIndex, setModalIndex] = useState(0);
    const touchStartX = useRef(null);
    const touchEndX = useRef(null);

    // Auto Carousel
    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex((prev) => (prev + 1) % slides.length);
        }, 6000);
        return () => clearInterval(interval);
    }, []);

    const handleTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX;
    };

    const handleTouchMove = (e) => {
        touchEndX.current = e.touches[0].clientX;
    };

    const handleTouchEnd = () => {
        const diff = touchStartX.current - touchEndX.current;
        if (diff > 50) {
            setActiveIndex((prev) => (prev + 1) % slides.length);
        } else if (diff < -50) {
            setActiveIndex((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
        }
    };

    const openModal = (index) => {
        setModalIndex(index);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    const handleNext = () => {
        setModalIndex((modalIndex + 1) % eventImages.length);
    };

    const handlePrev = () => {
        setModalIndex((modalIndex - 1 + eventImages.length) % eventImages.length);
    };

    return (
        <>
            {/* Carousel */}
            <div
                className="custom-carousel"
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
            >
                {slides.map((slide, index) => (
                    <div key={index} className={`custom-slide ${index === activeIndex ? "active" : ""}`}>
                        <img src={slide.img} loading="lazy" alt={`slide-${index}`} />
                        <div className="custom-caption">
                            <h2>{slide.text}</h2>
                        </div>
                    </div>
                ))}
            </div>

            {/* Events Section */}
            <div className='news-container'>
                <div className="events-section">
                    <h2>Our Events</h2>

                    <div className={`event-box-container ${visibleCount < eventImages.length ? 'fade-out' : 'fade-in'}`}>
                        {eventImages.slice(0, visibleCount).map((img, index) => (
                            <div className='event-box' key={index} onClick={() => openModal(index)}>
                                <img src={img} loading="lazy" alt={`event-${index}`} />
                            </div>
                        ))}
                    </div>

                    {visibleCount < eventImages.length && (
                        <div className="show-more-container">
                            <button className="show-more-btn" onClick={() => setVisibleCount(eventImages.length)}>
                                Show More
                            </button>
                        </div>
                    )}
                </div>
            </div>

            {/* Modal Viewer */}
            {showModal && (
                <div className="e-modal-overlay" onClick={closeModal}>
                    <div className="e-modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="e-close-btn" onClick={closeModal}>×</button>
                        <img src={eventImages[modalIndex]} loading="lazy" alt="event-large" />
                        <button className="e-modal-prev" onClick={handlePrev}>‹</button>
                        <button className="e-modal-next" onClick={handleNext}>›</button>
                    </div>
                </div>
            )}

            <Whatsapp />
        </>
    );
}

export default Media;
